import type { WReferenceLinkingToUrlContent } from "@/lib/api/cms-window-content";
import styles from "./WReferenceLinkingToUrl.module.css";

/**
 * WReferenceLinkingToUrl — renderer okna typu `w_reference_linking_to_url`.
 *
 * **Parytet z legacy** `component/w_reference_linking_to_url/VIEW/default_modern/
 * w_reference_linking_to_url_type_1_default_modern.imp`:
 *   - Nagłówek sekcji (`<h2>`) z `content.title` (= `imp_cms_window.name`)
 *   - Gdy `config.list_url` ustawione — owijamy `<a>` (CTA "więcej" / "zobacz wszystko")
 *   - Gdy `config.description` ustawione — `<p>` pod nagłówkiem (admin-friendly
 *     intro do sekcji, np. nad listą najnowszych wpisów)
 *
 * **Wariant `config.type`:** obecnie tylko `1` (domyślny). Pole zarezerwowane
 * na przyszłe warianty wizualne — admin może wybrać z `types` w pliku .lang,
 * ale frontend renderuje wszystkie jako `type=1` dopóki nie pojawi się nowy
 * wzorzec wizualny.
 *
 * Server component (brak hooków, brak state) — fully prerendered.
 */
export default function WReferenceLinkingToUrl({ content }: WReferenceLinkingToUrlProps) {
  if (!content) return null;

  const { title, config } = content;
  if (!title) return null;

  /* Backend dopuszcza inline HTML w nazwie okna (legacy `.imp` echo'wał raw).
     Trust source: admin-defined w IADMIN, sanitized przez framework. */
  const titleNode = <span dangerouslySetInnerHTML={{ __html: title }} />;

  return (
    <div className={styles.root}>
      <h2 className={styles.title}>
        {config.list_url ? (
          <a href={config.list_url} className={styles.link}>
            {titleNode}
          </a>
        ) : (
          titleNode
        )}
      </h2>
      {config.description && (
        <p
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: config.description }}
        />
      )}
    </div>
  );
}

export type WReferenceLinkingToUrlProps = {
  content: WReferenceLinkingToUrlContent | null;
};
